import styled, { css } from 'styled-components';

import { ArrowRightIcon as ArrowRight } from "../Icons/components/ArrowRight";
import { Button } from "../Buttons/ButtonV2";
import { elevation } from "../Styles/Utils";

const defaultSizeInPixels = 48;

export const FunctionalButton = /*#__PURE__*/styled.button.attrs({ type: 'button' }).withConfig({ displayName: "styles__FunctionalButton", componentId: "sc-1fwhkk0-0" })(["all:unset;cursor:pointer;-webkit-tap-highlight-color:transparent;:disabled{cursor:default;}"]);









export const Link = /*#__PURE__*/styled.a.attrs({ rel: 'noopener noreferrer' }).withConfig({ displayName: "styles__Link", componentId: "sc-1fwhkk0-1" })(["all:unset;cursor:pointer;-webkit-tap-highlight-color:transparent;"]);






export const CircleContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__CircleContainer", componentId: "sc-1fwhkk0-2" })(["width:", "px;height:", "px;grid-area:icon;place-self:center left;position:relative;"],
defaultSizeInPixels,
defaultSizeInPixels);





export const CircleBadge = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__CircleBadge", componentId: "sc-1fwhkk0-3" })(["position:absolute;right:0;bottom:0;overflow:hidden;display:flex;justify-content:center;align-items:center;box-sizing:border-box;min-width:20px;max-width:100%;height:20px;border-radius:20px;border-style:solid;border-width:", "px;border-color:", ";background-color:", ";", ""],













(props) => props.borderColor ? 2 : 0,
(props) => props.borderColor ?? 'transparent',
(props) =>
props.backgroundColor || props.theme.colors.ElementBackground,

elevation(1, false));


export const CircleBadgeText = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__CircleBadgeText", componentId: "sc-1fwhkk0-4" })(["", " color:", ";font-size:12px;line-height:20px;padding:0 2px;overflow:hidden;white-space:nowrap;text-align:left;text-overflow:ellipsis;"],
(props) => css(props.theme.typography.SmallHeadline),
(props) => props.color ?? props.theme.colors.Foreground);










export const Title = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Title", componentId: "sc-1fwhkk0-5" })(["", " color:", ";grid-area:title;align-self:end;max-width:100%;overflow:hidden;white-space:nowrap;text-align:left;text-overflow:ellipsis;margin:auto 0;"],
(props) => css(props.theme.typography.SmallHeadline),
(props) => props.color ?? props.theme.colors.Foreground);












export const Description = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Description", componentId: "sc-1fwhkk0-6" })(["", " color:", ";margin:0;grid-area:description;align-self:start;max-width:100%;overflow:hidden;white-space:nowrap;text-align:left;text-overflow:ellipsis;"],
(props) => css(props.theme.typography.TinyParagraph),
(props) => props.color ?? props.theme.colors['Level 5']);












export const ArrowRightIcon = /*#__PURE__*/styled(ArrowRight).withConfig({ displayName: "styles__ArrowRightIcon", componentId: "sc-1fwhkk0-7" })(["grid-area:action-pointer;place-self:center end;"]);




export const AdditionalButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__AdditionalButton", componentId: "sc-1fwhkk0-8" })(["grid-area:action-pointer;place-self:center end;z-index:1;&:hover{", "}> *{font-weight:500;}"],






elevation(2, true));







export const RightContent = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__RightContent", componentId: "sc-1fwhkk0-9" })(["grid-area:action-pointer;place-self:center end;font-size:", ";color:", ";z-index:1;> *{font-weight:", ";}"],


(props) => props.theme.typography.TinyParagraph.fontSize,
(props) => props.color ?? props.theme.colors['Level 5'],




(props) => props.theme.typography.TinyParagraph.fontWeight);



export const Circle = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Circle", componentId: "sc-1fwhkk0-10" })(["width:100%;height:100%;display:flex;justify-content:center;align-items:center;border-radius:50%;border-width:2px;border-style:solid;border-color:", ";background-color:", ";overflow:hidden;box-sizing:border-box;> *:nth-child(2){z-index:1;}"],








(props) => props.borderColor ?? 'transparent',
(props) =>
props.backgroundColor ?? props.theme.colors.secondaryBackground);








export const Delimiter = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Delimiter", componentId: "sc-1fwhkk0-11" })(["grid-area:delimiter;grid-column:2 / -1;background-color:", ";"],


(props) => props.theme.colors['Level 1']);


export const RippleContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__RippleContainer", componentId: "sc-1fwhkk0-12" })(["grid-column:1 / -1;grid-row:1 / -2;border-radius:4px;"]);





export const Content = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Content", componentId: "sc-1fwhkk0-13" })(["position:relative;display:grid;grid-row-gap:0;grid-column-gap:8px;grid-template-columns:auto 1fr auto;grid-template-rows:12px auto 5px auto 12px ", "px;grid-template-areas:'. . .' 'icon title action-pointer' 'icon . action-pointer' 'icon description action-pointer' '. . .' 'delimiter delimiter delimiter';", " ", ""],















(props) => props.hasDelimiter ? 2 : 0,








(props) =>
props.isTransparent &&
css(["", ",", ",", ",", "{opacity:0.5;}"],
Circle, Title, Description, ArrowRightIcon),




(props) =>
!props.hasDescription &&
css(["grid-template-rows:12px auto 12px ", "px;grid-template-areas:'. . .' 'icon title action-pointer' '. . .' 'delimiter delimiter delimiter';"],




props.hasDelimiter ? 2 : 0));